import { useTranslate } from '@tolgee/react';
import React from 'react';
import backgroundImage from '../../../assets/images/Home-image.jpg';
import Logo from '../../../assets/images/Logo.png';
import { useGlobalContext } from '../../../global-context/GlobalContext';
import './AnalyticsDownload.scss';

interface AnalyticsDownloadProps {
  reportDate: string;
  period: string;
  logoSrc: string;
  logoAlt: string;
  personImageSrc: string;
  fridgeImageSrc: string;
  personImageAlt: string;
  fridgeImageAlt: string;
}

const baseUrl = process.env.REACT_APP_BASE_URL_IMAGE;

const AnalyticsDownload: React.FC<any> = ({
  reportDate,
  period,
  logoSrc,
  logoAlt,
  personImageSrc,
  fridgeImageSrc,
  personImageAlt,
  fridgeImageAlt,
}) => {
  const companyName = useGlobalContext(
    c => c.auth.companyInfo?.abbreviatedCompanyName,
  );
  const { t } = useTranslate();
  return (
    <div className='sales-statistics'>
      <div className='sales-statistics__header'>
        <div>
          <p className='sales-statistics__header-title'> {companyName}</p>
          <p className='sales-statistics__header-paragraph'>
            {t('analytics.report-prepared-on')} : {reportDate}
          </p>
        </div>
        <div className='sales-statistics__header-details'>
          <img src={Logo} alt='' height='45' />
        </div>
      </div>
      <div className='sales-statistics__header'>
        <div className='sales-statistics__title'>
          <h1>{t('analytics.salesStatistics')}</h1>
          <p>
            {t('analytics.period')} : {period}
          </p>
        </div>
        <div>
          <p
            style={{
              fontSize: '20px',
              fontFamily: '"myGramaticaMedium", Arial, sans-serif',
              margin: 0,
            }}
          >
            {companyName}
          </p>
        </div>
      </div>

      <div className='sales-statistics__content'>
        <div className='sales-statistics__org-details'>
          {/* <p>{organization}</p>
                    <p>{location}</p> */}
        </div>
      </div>
      <div className='sales-statistics__images'>
        <img
          className='sales-statistics__person-image'
          src={backgroundImage}
          alt={personImageAlt}
        />
      </div>
    </div>
  );
};

export default AnalyticsDownload;
